import { RootWrapper } from 'components/RootWrapper';
import { Shell } from 'pages/Shell/Shell';
import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './fonts.css';
import './style.css';
import HomePage from 'pages/HomePage/HomePage';
import { createRoot } from 'react-dom/client';
import { DIGITAL_CFO_DASHBOARD_ROUTE } from 'utils/constants';

createRoot(document.getElementById('appRoot')).render(
    <React.StrictMode>
        <RootWrapper>
            <Router>
                <Switch>
                    <Route
                        path={DIGITAL_CFO_DASHBOARD_ROUTE.URL}
                        component={() => (
                            <Shell
                                contextName={DIGITAL_CFO_DASHBOARD_ROUTE.CONTEXT_NAME}
                                multiLogin={DIGITAL_CFO_DASHBOARD_ROUTE.MULTILOGIN}
                            />
                        )}
                    />
                    <Route path="/" component={() => <HomePage />} />
                </Switch>
            </Router>
        </RootWrapper>
    </React.StrictMode>
);
